<template>
  <div class="basic_vip_header" v-if="$store.state.vip.switch && zxtVisible">
    <img
      class="header_vip_logo"
      :src="`https://staticjs.71360.com/3/static/image/${$store.state.vip.level}_years.png`"
    />
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'basic_vip_header',
  props: {
    module: {
      type: Object,
      default: null
    }
  },
  computed: {
    zxtVisible() {
      return Number(this.$store.state.app.road_type) !== 1
    }
  },
  mounted() {
    console.log(this.$store.state.myRender.common.vip_type)
  }
}
</script>

<style lang="scss" scoped>
.basic_vip_header {
  .header_vip_logo {
    width: 100%;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_vip_header/index.vue